export { publicOfferModel as model } from './model';
